jQuery(document).ready(function($) {
  var navigation = new Navigation({ click: true });
  navigation.init()
});